import {ModelBase} from "../model-base";
import {IModelBase} from "../i-model-base";

export class SourceDetailDto extends ModelBase implements IModelBase {
  // item: ItemNl = new ItemNl();
  // inventoryId: number | undefined;
  purchasePricePerComposite: number = 0;
  // volumePerUnit: number = 0;
  // unitsPerBundle: number = 0;
  // supplierKey: string = "";
}
